module.exports = __webpack_public_path__ + "static/media/car.17187177.png";